import { Injectable, inject } from '@angular/core';
import { SentryService } from './sentry.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private sentryService = inject(SentryService);

  public signIn(userId: string, operatorId: string): void {
    this.sentryService.setUserId(userId);
    this.sentryService.setOperator(operatorId);
  }

  public logBreadcrumb(name: string, params: object = {}): void {
    this.sentryService.addBreadcrumb(name, params);
  }

  public logMessage(message: string): void {
    this.sentryService.captureMessage(message);
  }

  public handleError<T extends Record<string, unknown>>(
    err: unknown,
    context?: string,
    data?: T,
  ): void {
    this.sentryService.captureException(err, context, data);
  }
}
